<dv-dialog-content>
  <img src="assets/thanks_donation.png" />

  <div class="dv-headline-lg">{{ 'PurchaseSuccessDialog.BodyText' | translate }}</div>
  <dv-button footer-right (click)="onClose()">
    {{ 'Button.Cancel' | translate }}
  </dv-button></dv-dialog-content
>
